<template>
    <div class="item-type-video">
        <div v-show="item.isVideo && item.hasVimeoId && vimeoReady" ref="vimeo" class="video-responsive"></div>
        <div v-show="item.hasVimeoId && !vimeoReady" class="vimeo-loading">
            <div>Video is initialising <strong>{{ item.title }}</strong>...</div>
        </div>
        <div class="alert alert-danger" role="alert" v-if="item.isVideo && !item.hasVimeoId">
            <i class="fas fa-exclamation-circle"></i> There was a problem loading this video.
        </div>
    </div>
</template>

<script>
import Player from '@vimeo/player';

export default {
    name: 'Video',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            vimeoPlayer: false,
            vimeoReady: false,
        }
    },
    mounted() {
        //console.table(this.item);
        if (this.item.isVideo && this.item.hasVimeoId) {
           this.initVimeo(this.item.vimeoId);
        }
    },
    watch: {
        'item.file_id': {
            handler(newValue) {
                this.destroyVimeo();
                const files = this.item.files.data;
                const previewFile = files.filter(item => item.uuid === newValue).pop();
                const vimeoId = previewFile.metadata.vimeo.vimeo_id;
                this.initVimeo(vimeoId);
            },
        },
        'item.status': {
            handler(newValue) {
                if (newValue === 'processing') {
                    this.vimeoPlayer.pause().then(() => {
                        // the video was paused
                    }).catch(function(error) {
                        console.error('Vimeo player - pause', error);
                    });
                }
            }
        }
    },
    methods: {
        initVimeo(vimeoId) {
            this.vimeoPlayer = new Player(this.$refs.vimeo, {
                id: vimeoId,
                width: 1920,
                height: 1080,
                title: false,
                autoplay: true,
                loop: true
            });

             // Events
            this.vimeoPlayer.ready().then(() => {
                this.vimeoReady = true;
            });
        },
        destroyVimeo() {
            this.vimeoPlayer.destroy();
            this.vimeoPlayer = null;
            this.vimeoReady = false;
        }
    },
    destroy() {
        if (this.item.isVideo && this.item.hasVimeoId && typeof this.vimeoPlayer === 'object') {
            this.destroyVimeo();
        }
    }
 }
</script>

<style lang="scss" scoped>
.item-type-video {
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
